import { CarlineBase, CarlinesWithSalesgroups } from 'src/types';

export const findCarlineFromSalesgroup = (
	carlines: CarlineBase[] | CarlinesWithSalesgroups[],
	code: number,
) =>
	carlines.find((carline: CarlinesWithSalesgroups) => {
		return carline.salesGroups?.find(
			salesgroup => salesgroup.code === code,
		);
	});
